/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {executeSetCashtag} from '../api'

export const useMutationExecuteSetCashtag = createReactQueryMutationHook('executeSetCashtag', executeSetCashtag)
